import { CardContent } from "@mui/material";
import axios from "axios";
import { Markup } from "interweave";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { Card, Carousel } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { serverInfo } from "../../../../App";
import Navigation from "../../../../components/Layouts/Header/Navigation";

import FileUpload from "./FileUpload";
import "./ParticipateGuitarChord.css";

const VideoUploadAudition = () => {

  const { imageCdnUrl } = useContext(serverInfo);


  const params = useParams();
  const [participateAudition, setParticipant] = useState([]);

  useEffect(() => {
    axios.get(`/api/user/audition/participate/${params.id}`).then((res) => {
      setParticipant(res.data.participateAudition);
    });
  }, [params.id]);

  return (
    <div>
      <Navigation />

      {participateAudition.map((audition) => (
        <>
          <Carousel>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={imageCdnUrl + audition?.banner}
                alt="First slide"
              />
            </Carousel.Item>
          </Carousel>
          <div className="container">
            <div className="d-flex justify-content-center mb-3">
              {audition.judge.map((judge) => (
                <>
                  <div className="avater-img mb-3 mx-2 text-center">
                    <img
                      src={imageCdnUrl + judge.user?.image}
                      className="img-fluid avatar-img-src"
                      alt=""
                    />
                  </div>
                </>
              ))}
            </div>
            <div>
              <div>
                <Card
                  style={{ backgroundColor: "#25272b" }}
                  sx={{ minWidth: 275 }}
                >
                  <CardContent>
                    <div className="row whole-m-p">
                      <div className="col-md-12">
                        <h4 className="starChat-heading">{audition.title}</h4>

                        <div className="vb"></div>

                        <div className="mt-3 row">
                          <div className="col-md-6 display-style-starChat">
                            <div className="me-5 starChat-child-style text-white">
                              <h6>Start</h6>
                              <h6>End</h6>
                              <h6>Fee</h6>
                            </div>

                            <div
                              style={{ color: "#c2c2c2" }}
                              className="mx-5 starChat-child-style"
                            >
                              <h6>
                                {moment(audition.start_time).format("LL")}
                              </h6>
                              <h6>{moment(audition.end_time).format("LL")}</h6>
                              <h6>${audition.fee}</h6>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="mx-2 starChat-child-style">
                              <h5 className="text-white">Description</h5>
                              <p style={{ color: "#c2c2c2" }}>
                                <Markup content={audition.description} />
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>

                <Card
                  className="my-4"
                  style={{ backgroundColor: "#25272b" }}
                  sx={{ minWidth: 275 }}
                >
                  <CardContent>
                    <FileUpload id={params.id} />
                  </CardContent>
                </Card>
              </div>
            </div>
          </div>
        </>
      ))}
    </div>
  );
};

export default VideoUploadAudition;
